import { FC, ReactNode, useMemo } from 'react'

import * as S from './PercentageChange.styles'

type PercentageChangeProps = {
  className?: string
  inverted?: boolean
  showArrow?: boolean
  small?: boolean
  start?: number
  end?: number
  prefix?: ReactNode
  suffix?: ReactNode
  renderWhenZero?: ReactNode
}

export const PercentageChange: FC<PercentageChangeProps> = ({
  className,
  inverted,
  showArrow = false,
  small,
  start,
  end,
  prefix,
  suffix,
  renderWhenZero,
}) => {
  const [isPositive, content] = useMemo(() => {
    if (start === undefined || end === undefined) {
      return [null, null]
    }
    if (start === end) {
      return [null, renderWhenZero]
    }
    const isPositive = start < end
    const percent = ((end - start) / start) * 100
    const numText = Number.isInteger(percent) ? String(percent) : percent.toFixed(2)
    const isZero = numText === '0' || /^[+-]?0\.00$/.test(numText)
    if (renderWhenZero && isZero) {
      return [null, renderWhenZero]
    }
    return [isPositive, `${isPositive ? '+' : ''}${numText}%`]
  }, [start, end, renderWhenZero])

  if (isPositive === null) {
    return content
  }

  return (
    <>
      {prefix}
      <S.PercentageChangeWrapper
        className={className}
        positive={inverted ? !isPositive : isPositive}
        small={small}
      >
        {showArrow && (isPositive ? <S.ArrowUp /> : <S.ArrowDown />)}
        {content}
      </S.PercentageChangeWrapper>
      {suffix}
    </>
  )
}
